export default __webpack_public_path__ + "static/media/DtVmJx26TKEr37c9YLJvilQs6yLUrwB0lw.324425e4.woff2";